var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "mb-1", attrs: { outlined: "" } },
    [
      _c(
        "v-row",
        {
          staticClass: "ma-0 py-1 px-1",
          staticStyle: { "flex-wrap": "nowrap" },
          attrs: { align: "center", "no-gutters": "" },
        },
        [
          _c("v-col", { staticClass: "py-0 px-1", attrs: { cols: "1" } }, [
            _c(
              "div",
              {
                staticClass: "readonly-field-label text-caption primary--text",
              },
              [_vm._v(" " + _vm._s(_vm.$t("label.documentNumber")) + " ")]
            ),
            _c(
              "div",
              {
                staticClass: "font-weight-bold mt-1",
                staticStyle: { "font-size": "1rem", "letter-spacing": "0.3px" },
              },
              [_vm._v(" " + _vm._s(_vm.houseBl.documentNbr) + " ")]
            ),
          ]),
          _c("v-divider", { attrs: { vertical: "" } }),
          _c(
            "v-col",
            {
              staticClass: "py-0 px-2 d-flex align-center justify-center",
              attrs: { cols: "3" },
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0 px-2 text-caption",
                      staticStyle: { "min-width": "0" },
                    },
                    [
                      _c("ReadonlyField", {
                        staticClass: "compact-field truncate-text",
                        attrs: {
                          label: _vm.$t("label.shipper"),
                          value: _vm.houseBl.shipperName,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0 px-2 text-caption",
                      staticStyle: { "min-width": "0" },
                    },
                    [
                      _c("ReadonlyField", {
                        staticClass: "compact-field truncate-text",
                        attrs: {
                          label: _vm.$t("label.consignee"),
                          value: _vm.houseBl.consigneeName,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider", { attrs: { vertical: "" } }),
          _c(
            "v-col",
            {
              staticClass: "py-0 px-2 d-flex align-center justify-center",
              attrs: { cols: "3" },
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0 px-2 text-caption",
                      staticStyle: { "min-width": "0" },
                    },
                    [
                      _c("ReadonlyField", {
                        staticClass: "compact-field truncate-text",
                        attrs: {
                          label: _vm.$t("label.clientFm"),
                          value: _vm.houseBl.clientFmName,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0 px-2 text-caption",
                      staticStyle: { "min-width": "0" },
                    },
                    [
                      _c("ReadonlyField", {
                        staticClass: "compact-field truncate-text",
                        attrs: {
                          label: _vm.$t("label.clientTo"),
                          value: _vm.houseBl.clientToName,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider", { attrs: { vertical: "" } }),
          _c(
            "v-col",
            {
              staticClass: "py-0 px-2 d-flex align-center justify-center",
              attrs: { cols: "1" },
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0 px-2 text-caption",
                      attrs: { cols: "10" },
                    },
                    [
                      _c("ReadonlyField", {
                        staticClass: "compact-field truncate-text",
                        attrs: {
                          label: _vm.$t("label.billOfLading"),
                          value: _vm.houseBl.billOfLading,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider", { attrs: { vertical: "" } }),
          _c(
            "v-col",
            {
              staticClass: "py-0 px-2 d-flex align-center justify-center",
              attrs: { cols: "4" },
            },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-0",
                  staticStyle: { "flex-wrap": "nowrap", width: "100%" },
                  attrs: { align: "center", justify: "center" },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pa-1 d-flex flex-column align-center",
                      attrs: { cols: "3" },
                    },
                    [
                      _c(
                        "v-avatar",
                        {
                          staticStyle: {
                            border: "2px solid var(--v-primary-base)",
                          },
                          attrs: { size: "36" },
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { size: "18", color: "primary" } },
                            [_vm._v("mdi-ferry")]
                          ),
                        ],
                        1
                      ),
                      _c("span", { staticClass: "location-label mt-1" }, [
                        _vm._v(_vm._s(_vm.houseBl.masterBl.polLabel)),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "pa-0 d-flex flex-column align-center",
                      attrs: { cols: "5" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex align-center",
                          staticStyle: { width: "100%" },
                        },
                        [
                          _c("v-divider"),
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "flex-shrink": "0" },
                              attrs: { size: "12", color: "primary" },
                            },
                            [_vm._v("mdi-navigation-variant")]
                          ),
                          _c("v-divider"),
                        ],
                        1
                      ),
                      _c("span", { staticClass: "vessel-name mt-1" }, [
                        _vm._v(_vm._s(_vm.houseBl.masterBl.vesselName)),
                      ]),
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "pa-1 d-flex flex-column align-center",
                      attrs: { cols: "3" },
                    },
                    [
                      _c(
                        "v-avatar",
                        {
                          staticStyle: {
                            border: "2px solid var(--v-primary-base)",
                          },
                          attrs: { size: "36" },
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { size: "18", color: "primary" } },
                            [_vm._v("mdi-ferry")]
                          ),
                        ],
                        1
                      ),
                      _c("span", { staticClass: "location-label mt-1" }, [
                        _vm._v(_vm._s(_vm.houseBl.masterBl.podLabel)),
                      ]),
                    ],
                    1
                  ),
                  _c("v-divider", { attrs: { vertical: "" } }),
                  _c(
                    "v-col",
                    {
                      staticClass: "pa-0 d-flex ml-4",
                      staticStyle: { "min-width": "40px" },
                      attrs: { cols: "auto" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", small: "", color: "primary" },
                          on: { click: _vm.goToHouseBL },
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-eye"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }